var $a53e00b683950971$exports = {};
$a53e00b683950971$exports = {
  "alpha": "\u0386\u03BB\u03C6\u03B1",
  "black": "\u03BC\u03B1\u03CD\u03C1\u03BF",
  "blue": "\u039C\u03C0\u03BB\u03B5",
  "blue purple": "\u03BC\u03C0\u03BB\u03B5 \u03BC\u03C9\u03B2",
  "brightness": "\u03A6\u03C9\u03C4\u03B5\u03B9\u03BD\u03CC\u03C4\u03B7\u03C4\u03B1",
  "brown": "\u03BA\u03B1\u03C6\u03AD",
  "brown yellow": "\u03BA\u03B1\u03C6\u03AD \u03BA\u03AF\u03C4\u03C1\u03B9\u03BD\u03BF",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "\u03BA\u03C5\u03B1\u03BD\u03CC",
  "cyan blue": "\u03BA\u03C5\u03B1\u03BD\u03CC \u03BC\u03C0\u03BB\u03B5",
  "dark": "\u03C3\u03BA\u03BF\u03CD\u03C1\u03BF",
  "gray": "\u03B3\u03BA\u03C1\u03B9",
  "grayish": "\u03B3\u03BA\u03C1\u03B9\u03B6\u03C9\u03C0\u03CC",
  "green": "\u03A0\u03C1\u03AC\u03C3\u03B9\u03BD\u03BF",
  "green cyan": "\u03C0\u03C1\u03AC\u03C3\u03B9\u03BD\u03BF \u03BA\u03C5\u03B1\u03BD\u03CC",
  "hue": "\u03A4\u03CC\u03BD\u03BF\u03C2",
  "light": "\u03B1\u03BD\u03BF\u03B9\u03C7\u03C4\u03CC",
  "lightness": "\u03A6\u03C9\u03C4\u03B5\u03B9\u03BD\u03CC\u03C4\u03B7\u03C4\u03B1",
  "magenta": "\u03BC\u03B1\u03C4\u03B6\u03AD\u03BD\u03C4\u03B1",
  "magenta pink": "\u03BC\u03B1\u03C4\u03B6\u03AD\u03BD\u03C4\u03B1 \u03C1\u03BF\u03B6",
  "orange": "\u03C0\u03BF\u03C1\u03C4\u03BF\u03BA\u03B1\u03BB\u03AF",
  "orange yellow": "\u03C0\u03BF\u03C1\u03C4\u03BF\u03BA\u03B1\u03BB\u03AF \u03BA\u03AF\u03C4\u03C1\u03B9\u03BD\u03BF",
  "pale": "\u03B1\u03BD\u03BF\u03B9\u03C7\u03C4\u03CC",
  "pink": "\u03C1\u03BF\u03B6",
  "pink red": "\u03C1\u03BF\u03B6 \u03BA\u03CC\u03BA\u03BA\u03B9\u03BD\u03BF",
  "purple": "\u03BC\u03C9\u03B2",
  "purple magenta": "\u03BC\u03C9\u03B2 \u03BC\u03B1\u03C4\u03B6\u03AD\u03BD\u03C4\u03B1",
  "red": "\u039A\u03CC\u03BA\u03BA\u03B9\u03BD\u03BF",
  "red orange": "\u03BA\u03CC\u03BA\u03BA\u03B9\u03BD\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03BA\u03B1\u03BB\u03AF",
  "saturation": "\u039A\u03BF\u03C1\u03B5\u03C3\u03BC\u03CC\u03C2",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " \u03B4\u03B9\u03B1\u03C6\u03B1\u03BD\u03AD\u03C2");
  },
  "very dark": "\u03C0\u03BF\u03BB\u03CD \u03C3\u03BA\u03BF\u03CD\u03C1\u03BF",
  "very light": "\u03C0\u03BF\u03BB\u03CD \u03B1\u03BD\u03BF\u03B9\u03C7\u03C4\u03CC",
  "vibrant": "\u03AD\u03BD\u03C4\u03BF\u03BD\u03BF",
  "white": "\u03BB\u03B5\u03C5\u03BA\u03CC",
  "yellow": "\u03BA\u03AF\u03C4\u03C1\u03B9\u03BD\u03BF",
  "yellow green": "\u03BA\u03AF\u03C4\u03C1\u03B9\u03BD\u03BF \u03C0\u03C1\u03AC\u03C3\u03B9\u03BD\u03BF"
};
export { $a53e00b683950971$exports as default };